<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'便利機能'">
          <list-item :spanText="'Q. '" :text="'睡眠目標の設定変更による影響について'" :urlName="'Help27'"></list-item>
          <list-item :spanText="'Q. '" :text="'WeBandの天気情報は現在の天気と異なる原因'" :urlName="'Help20'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory36.vue